import { SVGProps, Ref, forwardRef } from 'react';

export const HumanWalkFilledSize24Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <path
                d="M7.577 16.905c.336.33.768.674 1.202 1.022l.682.546L9.003 20l-3.318 3.77a.676.676 0 0 1-1.088-.793L7.003 19l.486-2.185q.044.046.088.09"
                fill="currentColor"
            />
            <path
                d="M12.178 7c1.203 0 2.105 1.1 1.87 2.28l-1.045 5.22 1.645 2.879c.177.31.266.465.325.632.06.167.089.343.148.695l.731 4.387a.78.78 0 0 1-1.516.351L13.003 19l-3.1-2.48c-.924-.74-1.387-1.11-1.58-1.637-.191-.527-.075-1.108.157-2.27L9.003 10l-2.5 1.5-.434 3.04a.536.536 0 0 1-1.066-.075v-3.31c0-.15 0-.226.005-.298.038-.528.284-1.02.684-1.368.054-.046.114-.092.234-.181l.536-.403A9.53 9.53 0 0 1 12.178 7"
                fill="currentColor"
            />
            <path d="M19.078 10.894A.562.562 0 0 1 18.942 12h-3.605l.39-1.944z" fill="currentColor" />
            <path d="M12.503 0c2.25 0 3 1.5 3 3s-.75 3-3 3-3-1.5-3-3 .75-3 3-3" fill="currentColor" />
        </g>
    </svg>
));
HumanWalkFilledSize24Glyph.displayName = 'HumanWalkFilledSize24Glyph';
